/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const kernel = require('../kernel/kernel')
const CValeur = require('./CValeur')
module.exports = CValeurAngle
// Modifié par rapport à la verion Java : hérite de CValeur

/**
 * Classe représentant une valeur dynamique d'angle définie par un calcul sur des objets
 * numériques de la figure.
 * @constructor
 * @extends CValeur
 * @param {CListeObjets} listeProprietaire
 * @param {CCb} calcul : pointe sur le calcul donnant le résultat
 * @returns {CValeurAngle}
 */
function CValeurAngle (listeProprietaire, calcul) {
   CValeur.call(this, listeProprietaire, calcul);
}
CValeurAngle.prototype = new CValeur();
CValeurAngle.prototype.constructor = CValeurAngle;
CValeurAngle.prototype.superClass = "CValeur";
CValeurAngle.prototype.className = "CValeurAngle";

CValeurAngle.prototype.getClone = function(listeSource, listeCible) {
  var calculClone = this.calcul.getClone(listeSource, listeCible);
  return new CValeurAngle(listeCible, calculClone, this.valeur);
};
CValeurAngle.prototype.rendValeurRadian = function() {
  var val = this.valeur;
  if (this.listeProprietaire.uniteAngle === kernel.uniteAngle.degre) val = val*kernel.ConvDegRad;
  val = kernel.mesurePrincipale(val);
  return val;
};



// WEBPACK FOOTER //
// ./src/objets/CValeurAngle.js